import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

// general single slide slider with fade effect
const sliderFeature = new Swiper(".slider-feature", {
    followFinger: false,
    grabCursor: false, 
    loop: true,
    mousewheel: false,
    speed: 800,
    watchSlidesProgress: true,
    effect: "fade",
    fadeEffect: {
        crossFade: true
    },
    navigation: {
        prevEl: ".slider-prev",
        nextEl: ".slider-next",
    },
    pagination: {
        el: ".slider-pagination",
        clickable: true
    },
});

const sliderImages = new Swiper(".slider-images", {
    direction: "vertical",
    followFinger: false,
    grabCursor: true, 
    longSwipesRatio: 0.01,
    loop: true,
    mousewheel: true,
    parallax: true,
    watchSlidesProgress: true,
    lazy: {
        loadPrevNext: true,
    },
});

// make sure sliders are synced
sliderFeature.controller.control = sliderImages;
